import { defineStore } from 'pinia'
import axios from 'axios'
import { useStorage } from '@vueuse/core'
import { useLoadingStore } from "@/store/loading";
import { localStorageKeyPrefix, user_company } from "@/constants";

export const useReportStore = defineStore('report',{
  state: () => {
    return {
      charts: useStorage(localStorageKeyPrefix + 'charts', [{
          id: 1,
          name: 'Pie Chart',
          model: 'PieChart'
        }
      ]),
      onlyReports: useStorage(localStorageKeyPrefix + 'onlyReports', []),
      reports: useStorage(localStorageKeyPrefix + 'reports', []),
      charts_data: useStorage(localStorageKeyPrefix + 'charts_data', [])
    }
  },
  getters: {
    allCharts: state => state.charts,
    chart: (state) => (report_id) => state.charts_data.find(chart => chart.report_id === report_id),
    reportsList: state => state.reports,
    findReport: state => report_id => state.onlyReports.find(report => report.id == report_id),
  },
  actions: {
    // Get list of all Reports
    async getReports() {
        const loadingStore = useLoadingStore()
        loadingStore.setLoading(true)
        const id = user_company
        const thisStore = this
        return await axios.get('/companies/' + id + '/reports?charts_only=true').then(function (response) {
          if (response.status === 200) {
            thisStore.reports = response.data
            const onlyReportsArray = []
            response.data.forEach(element => {
              if (element.report.length) {
                element.report.forEach(report => {
                  if (onlyReportsArray.indexOf(report) == -1) {
                    onlyReportsArray.push(report)
                    thisStore.setReport(report)
                  }
                })
              }
            });
          }
          loadingStore.setLoading(false)
        })
    },
    // Get single report
    async getReport(id) {
      const loadingStore = useLoadingStore()
      loadingStore.setLoading(true)
      return await axios.get('/reports/' + id).then(response => {
        if (response.status === 200) {
          this.setReport(response.data)
          loadingStore.setLoading(false)
          if(response.data.chart_id != null) {
            this.getChart(response.data)
          }
        }
      })
    },
    // Get list of all Charts
    async getCharts() {
      const loadingStore = useLoadingStore()
      loadingStore.setLoading(true)
      const thisStore = this
      await axios.get('/charts').then(function (response) {
        if (response.status === 200) {
          thisStore.charts = response.data
          loadingStore.setLoading(false)
        }
      })
    },
    // Get Chart data
    async getChart(data) {
      const loadingStore = useLoadingStore()
      loadingStore.setLoading(true)
      const company_id = user_company
      const report_id = data.id
      const payload = {
        backward_interval: data.backward_interval,
        columns: data.view_columns,
        filters: data.filters,
        group_by: data.group_by,
        order_by: data.order_by,
        date_from: data.date_from,
        date_to: data.date_to,
        cover_type: data.cover_type,
        chart_id: data.chart_id,
        service: data.service.name,
        report_id,
      }
      return await axios.post('/companies/' + company_id + '/data.chart', payload).then(response => {
        if (response.status === 200 && response.data) {
          const output = response.data.chart
          output.chart_type_id = data.chart_id
          output.report_id = report_id
          this.setChartData(output)
          loadingStore.setLoading(false)
          return output
        }
      })
    },
    setReport(data) {
      const index = this.onlyReports.findIndex(report => report.id === data.id)
      if(index != -1){
        this.onlyReports.splice(index,1,data)
      } else {
        this.onlyReports.push(data)
      }
    },
    setChartData(data) {
      const index = this.charts_data.findIndex(chart => chart.report_id == data.report_id)
      if(index != -1) {
        this.charts_data.splice(index, 1, data)
      } else {
        this.charts_data.push(data)
      }
    },
  },
  strict: false,
})
